import { render, staticRenderFns } from "./shopOrder.vue?vue&type=template&id=283446e1&scoped=true&"
import script from "./shopOrder.vue?vue&type=script&lang=js&"
export * from "./shopOrder.vue?vue&type=script&lang=js&"
import style0 from "./shopOrder.vue?vue&type=style&index=0&id=283446e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283446e1",
  null
  
)

export default component.exports